import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';
import { Result, Button } from 'antd';


export class CCCCLTDPersonStoreDB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            canSubmt: false,
            infoMsg: "",
            errorMessage: "",
            applytId: "",
            timeStamp: "",
            tenantId: "",
            userId: "",
            signValue: ""
        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const applyId = urlParams.get("applyId");
        const timeStamp = urlParams.get("timeStamp");
        const tenantId = urlParams.get("tenantId");
        const userId = urlParams.get("userId");
        const signValue = urlParams.get("signValue");
        if (!applyId) {
            this.setState({ errorMessage: "应聘者申请Id不存在！", isLoading: false, isReady: true });
            return;
        }
        this.setState({ applyId, timeStamp, tenantId, userId, signValue });
        this.loadPage(tenantId, userId, applyId, timeStamp, signValue);
    };
    loadPage = (tenantId, userId, applyId, timeStamp, signValue) => {
        const params = {
            tenantId,
            userId,
            applyId,
            timeStamp,
            signValue
        }
        axios
            .get("/api/CCCCLTD/GetStoreDbInfo", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const wishInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "获取详细信息失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = wishInfo["canSubmit"];
                    infoMsg = wishInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });

            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    agree = () => {
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue
        }
        axios
            .get("/api/CCCCLTD/AgreeStoreDb", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {                  
                    errorMessage = "对不起，您在确认将简历信息储备至中国交建内部人才库时失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = false;
                    infoMsg = "您已确认将简历信息储备至中国交建内部人才库，感谢您的反馈。";
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    refuse = () => {
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue
        }
        axios
            .get("/api/CCCCLTD/RefuseStoreDb", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "对不起，您在放弃将简历信息储备至中国交建内部人才库时失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = false;
                    infoMsg = "您已放弃将简历信息储备至中国交建内部人才库，感谢您的反馈。";
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                if (this.state.canSubmt) {
                    return (<Result
                        extra={[
                            <br />,
                            <p style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>,
                            <br />,
                            <p style={{ textAlign: "center", marginRight: "0" }}>
                                <Button onClick={this.refuse} style={{ marginRight: "0" }}>放弃</Button>
                                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <Button type="primary" onClick={this.agree} style={{ marginLeft: "0" }}>确认</Button>
                            </p>
                        ]} />)
                } else {
                    return (<Result
                        status="success"
                        key = "wish"
                        extra={[
                            <br key= "br1"/>,
                            <p  key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>
                        ]}

                    />)
                }

            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}